import React from 'react';

const Querie_report = ({ item }) => {
  return (
    <div className="smoothie-card">
      <h3>Date:</h3>
      <p>{new Date(item.test_date).toLocaleDateString()}</p> {/* Format date to a more readable format */}
      <h3>Value:</h3>
      <p>{item.value}</p>
    </div>
  );
};

export default Querie_report;
